import { useCallback, useState } from 'react';
import UnauthorizedApiError from '@/interfaces/errors/unauthorized';
import ForbiddenApiError from '@/interfaces/errors/forbidden';
import NotFoundApiError from '@/interfaces/errors/notFound';
import * as widgetsApi from '@/services/api/widgets';
import * as errors from './errors';
const PREFIX = 'common: components: Editor: hooks: useDeleteWidget:'; // interface Params {}

export default function useDeleteWidget() {
  const {
    0: isConfirmDeleteWidgetPromptOpen,
    1: setIsConfirmDeleteWidgetPromptOpen
  } = useState(false); // Request to delete widget from project

  const deleteWidget = useCallback(widgetId => {
    return widgetsApi.deleteRecord(widgetId).catch(err => {
      if (err instanceof NotFoundApiError) {
        throw errors.createUnfoundError(`${PREFIX} deleteWidget`, err);
      } else if (err instanceof UnauthorizedApiError || err instanceof ForbiddenApiError) {
        throw errors.createUnpermissionedError(`${PREFIX} deleteWidget`, err);
      } else {
        throw errors.createUnknownError(`${PREFIX} deleteWidget:`, err);
      }
    });
  }, []); // Open/close toggle confirm widget delete prompt

  const toggleConfirmDeleteWidgetPrompt = useCallback(force => {
    if (typeof force === 'boolean') {
      setIsConfirmDeleteWidgetPromptOpen(force);
    } else {
      setIsConfirmDeleteWidgetPromptOpen(!isConfirmDeleteWidgetPromptOpen);
    }
  }, [isConfirmDeleteWidgetPromptOpen, setIsConfirmDeleteWidgetPromptOpen]);
  return {
    isConfirmDeleteWidgetPromptOpen,
    toggleConfirmDeleteWidgetPrompt,
    deleteWidget
  };
}